import type { State } from '../State';
import {
  SB,
  searchableComputedProperty,
  payloadComputedProperty,
} from '@play-co/replicant';
import { canAddFriends } from '../friends/friends.getters';

export const visitProperties = {
  /** Id of friend currently being visited, if any */
  visitingFriendId: searchableComputedProperty(
    SB.string(),
    ({ visit }: State) => visit.visitSession?.friendId ?? '',
  ),

  /**
   * Whether user can accept friendship requests (based on friend list limit).
   */
  canAcceptFriendRequest: payloadComputedProperty(
    SB.boolean().default(false),
    (state: State) => canAddFriends(state),
  ),
};
